// Skills Data
const skills = [
    {
        category: 'Languages',
        skills: ['Java', 'JavaScript', 'TypeScript', 'GraphQL', 'HTML/CSS']
    },
    {
        category: 'Frameworks',
        skills: ['React', 'Node.js', 'Spring']
    },
    {
        category: 'Tools',
        skills: ['Kiro', 'Git', 'Webpack', 'npm/yarn']
    },
    {
        category: 'Cloud',
        skills: ['AWS Lambda', 'DynamoDB', 'S3', 'CloudFormation', 'CloudWatch', 'API Gateway', 'Step Functions']
    }
];

export default skills;
